<script>
export default {
  name: "FieldNote",
  inject: [ 'store'],
  emits: ["onEvaluateValueResetter"],
  props: ["field"],
}
</script>

<template>
  <p v-if="field.id === store.NewNoteMsg.fieldID" class="calcNote">{{ store.NewNoteMsg.msg }}</p>
  <p v-else class="calcNote">{{ field.msg }}</p>
</template>